import { computed } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';

import z from 'z';

interface IProps {
  message?: string;
}

@observer
class Error extends React.Component<IProps> {
  static defaultProps: Partial<IProps> = {
    message: ''
  };

  render() {
    if (!this.show) {
      return null;
    }

    return (
      <div className="my-2 rounded-md border border-rose-300 bg-rose-100 p-3 text-center text-sm text-rose-600">
        {z.format(this.message)}
      </div>
    );
  }

  @computed
  private get show(): boolean {
    return !!this.props.message;
  }

  @computed
  private get message(): string {
    const { message } = this.props;
    return message?.replace('TM3', '{TM3}') ?? '';
  }
}

export default Error;
